import React, { useCallback } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { fetchLogin } from '@/store/auth/actions';

// Component that renders a native <form> for initiating the flow for connecting with Gmail.
// At least 1 submit button (which submits the form) is expected to be provided as `children` to this component.
// Example:
//   <ConnectWithMsForm user={user}>
//     <Button type="submit" variant="primary">
//       Connect
//     </Button>
//   </ConnectWithMsForm>
//
export const ConnectWithMsForm = ({ children, dispatch }) => {
  const onSubmit = useCallback(
    async (event) => {
      const form = event.target;

      // proceed with normal submit if CSRF token is already there
      if (form.elements['authenticity_token']?.value) return;

      // otherwise, fetch the CSRF token, attach it to the form, then submit
      event.preventDefault();

      const { data } = await dispatch(fetchLogin(undefined)).unwrap();
      const { csrf_token } = data;
      if (csrf_token) {
        // Set directly on the DOM element to avoid a React re-render race condition
        // where Safari fires form.submit() before the state update commits to the DOM.
        form.elements['authenticity_token'].value = csrf_token;
        form.submit();
      }
    },
    [dispatch]
  );

  const { tFeGoogleIncrementalScopes } = useFlags();

  const maOauthParams = new URLSearchParams({
    for: 'outlook',
    origin: window.location.href,
  });

  if (!tFeGoogleIncrementalScopes) {
    maOauthParams.delete('for'); // revert to old behaviour
  }

  return (
    <form
      method="post"
      action={`/api/v1/auth/microsoft_graph?${maOauthParams}`}
      onSubmit={onSubmit}
    >
      <input type="hidden" name="authenticity_token" defaultValue="" />
      {/* Not utilising this for outlook, Since it takes to password page , then to 2fa and then to consent, Which might be hard for users */}
      {/* <input type="hidden" name="login_hint" value={user?.email || ''} /> */}
      {children}
    </form>
  );
};
